import { render, staticRenderFns } from "./Donate.vue?vue&type=template&id=0488b802&"
import script from "./Donate.vue?vue&type=script&lang=ts&"
export * from "./Donate.vue?vue&type=script&lang=ts&"
import style0 from "./Donate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports